import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { SurveyDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { SurveyForm } from './SurveyForm';
import { PVAPage } from '../../components';

export class SurveyCreate extends React.Component<BaseRouteProps<{}>> {
    private surveyDataService = new SurveyDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/survey`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Survey
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <SurveyForm submit={(e: any) => this.save(e)} defaultValues={{}} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.surveyDataService.create(values).then((success) => {
            this.props.history.push(`/survey/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/survey/SurveyCreate.tsx